import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const isMobile =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

const routes = [
  {
    path: "/",
    redirect: () => {
      return isMobile ? "/questionnaire/wap/index" : "/questionnaire/pc/index";
    },
  },
  {
    path: "/questionnaire",
    name: "Questionnaire",
    component: () => import("../views/Questionnaire.vue"),
    children: [
      {
        path: "pc/index",
        name: "PcIndex",
        component: () => import("../views/questionnaire/pc/questionnaire.vue"),
        meta: {
          title: "问卷页面",
        },
      },
      {
        path: "pc/success",
        name: "PcSuccess",
        component: () => import("../views/questionnaire/pc/success.vue"),
        meta: {
          title: "成功页面",
        },
      },
      {
        path: "wap/index",
        name: "WapIndex",
        component: () => import("../views/questionnaire/wap/questionnaire.vue"),
        meta: {
          title: "问卷页面",
        },
      },
      {
        path: "wap/success",
        name: "WapSuccess",
        component: () => import("../views/questionnaire/wap/success.vue"),
        meta: {
          title: "成功页面",
        },
      },
    ],
  },
  {
    path: "/exam",
    name: "Exam",
    component: () => import("../views/Exam.vue"),
    children: [
      {
        path: "pc/index",
        name: "PcIndex",
        component: () => import("../views/exam/pc/questionnaire.vue"),
        meta: {
          title: "试卷页面",
        },
      },
      {
        path: "pc/result",
        name: "PcResult",
        component: () => import("../views/exam/pc/result.vue"),
        meta: {
          title: "答案页面",
        },
      },
      {
        path: "pc/success",
        name: "PcSuccess",
        component: () => import("../views/exam/pc/success.vue"),
        meta: {
          title: "成功页面",
        },
      },
      {
        path: "wap/index",
        name: "WapIndex",
        component: () => import("../views/exam/wap/questionnaire.vue"),
        meta: {
          title: "试卷页面",
        },
      },
      {
        path: "wap/result",
        name: "WapResult",
        component: () => import("../views/exam/wap/result.vue"),
        meta: {
          title: "答案页面",
        },
      },
      {
        path: "wap/success",
        name: "WapSuccess",
        component: () => import("../views/exam/wap/success.vue"),
        meta: {
          title: "成功页面",
        },
      },
    ],
  },
  {
    path: "/examRandom",
    name: "ExamRandom",
    component: () => import("../views/ExamRandom.vue"),
    children: [
      {
        path: "pc/index",
        name: "PcIndex",
        component: () => import("../views/exam-random/pc/questionnaire.vue"),
        meta: {
          title: "试卷页面",
        },
      },
      {
        path: "pc/result",
        name: "PcResult",
        component: () => import("../views/exam-random/pc/result.vue"),
        meta: {
          title: "答案页面",
        },
      },
      {
        path: "pc/success",
        name: "PcSuccess",
        component: () => import("../views/exam-random/pc/success.vue"),
        meta: {
          title: "成功页面",
        },
      },
      {
        path: "wap/index",
        name: "WapIndex",
        component: () => import("../views/exam-random/wap/questionnaire.vue"),
        meta: {
          title: "试卷页面",
        },
      },
      {
        path: "wap/result",
        name: "WapResult",
        component: () => import("../views/exam-random/wap/result.vue"),
        meta: {
          title: "答案页面",
        },
      },
      {
        path: "wap/success",
        name: "WapSuccess",
        component: () => import("../views/exam-random/wap/success.vue"),
        meta: {
          title: "成功页面",
        },
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;
